export { default as FacebookIcon } from './Facebook';
export { default as YoutubeIcon } from './Youtube';
export { default as LinkedInIcon } from './LinkedIn';
export { default as TwitterIcon } from './Twitter';
export { default as TiktokIcon } from './Tiktok';
export { default as InstagramIcon } from './Instagram';
export { default as MenuIcon } from './Menu';
export { default as CartIcon } from './Cart';
export { default as ProfileIcon } from './Profile';
export { default as SearchIcon } from './Search';
export { default as CloseIcon } from './Close';
export { default as ArrowLeftIcon } from './ArrowLeft';
export { default as Logo } from './logos/Logo';
export { default as LogoEye } from './logos/LogoEye';
export { default as AddOnIcon } from './AddOn';
export { default as Check } from './Check';
export { default as Minus } from './Minus';
export { default as Plus } from './Plus';
export { default as MessengerIcon } from './Messenger';
export { default as EmailIcon } from './Email';
export { default as AirplaneTakeOffIcon } from './AirplaneTakeOff';
export { default as PrepaidIcon } from './Prepaid';
export { default as Network5gIcon } from './Network5g';
export { default as Network4gIcon } from './Network4g';
export { default as Network3gIcon } from './Network3g';
export { default as NetworkGSMIcon } from './NetworkGSM';
export { default as NetworkIOTIcon } from './NetworkIOT';
export { default as PdfIcon } from './Pdf';
export { default as NoWifiIcon } from './NoWifi';
export { default as TVIcon } from './TV';
export { default as WifiGoodIcon } from './WifiGood';
export { default as MobileIcon } from './Mobile';
export { default as LocationPinIcon } from './LocationPin';
export { default as DeviceIcon } from './Device';
